module.exports = __webpack_public_path__ + "img/melchior.f00e667c.jpg";